import { api } from 'api';
import { call, put } from 'redux-saga/effects';
import { actionActions } from 'store/data/action';
import { JwtFeature } from 'utility/jwt';

import { operationWrapper } from './operationWrapper';

// Deletes an action via Action_Delete and removes it from the action domain.
// The store dispatch only fires on API success — operationWrapper catches
// errors via errorWrapper and short-circuits before the put.
export function* deleteAction(args: { actionId: string }) {
  const { actionId } = args;

  function* work(tenantId: string) {
    yield call(api.deleteAction, { tenantId, actionId });

    yield put(actionActions.remove(actionId));
  }

  yield call(operationWrapper, work, JwtFeature.Improvements);
}
